import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { Beef, Fish, Salad, UtensilsCrossed, Coffee, Cookie } from "lucide-react";
const categories = [
    {
        title: "Main Dishes",
        icon: Beef,
        count: 156,
        color: "text-[#c85a3f]"
    },
    {
        title: "Quick & Easy",
        icon: UtensilsCrossed,
        count: 89,
        color: "text-[#a8c5a4]"
    },
    {
        title: "Vegetarian",
        icon: Salad,
        count: 124,
        color: "text-[#f5d77e]"
    },
    {
        title: "Seafood",
        icon: Fish,
        count: 67,
        color: "text-[#c85a3f]"
    },
    {
        title: "Breakfast",
        icon: Coffee,
        count: 78,
        color: "text-[#a8c5a4]"
    },
    {
        title: "Desserts",
        icon: Cookie,
        count: 92,
        color: "text-[#f5d77e]"
    }
];
export function CategoriesSheet({ open, onOpenChange }) {
    return (_jsx(Sheet, { open: open, onOpenChange: onOpenChange, children: _jsxs(SheetContent, { side: "bottom", className: "h-[85vh] rounded-t-3xl border-t-4 border-border", children: [_jsxs(SheetHeader, { className: "text-left mb-6", children: [_jsx(SheetTitle, { className: "text-foreground", children: "Browse Categories" }), _jsx(SheetDescription, { children: "Explore recipes by type" })] }), _jsx("div", { className: "grid grid-cols-2 gap-4 pb-20", children: categories.map((category) => {
                        const Icon = category.icon;
                        return (_jsxs("button", { className: "group relative bg-card rounded-2xl border-2 border-border p-6 text-left hover:shadow-vintage transition-all active:scale-95 overflow-hidden", children: [_jsx("div", { className: "absolute -right-4 -bottom-4 w-24 h-24 rounded-full bg-accent/10 group-hover:scale-110 transition-transform" }), _jsxs("div", { className: "relative space-y-3", children: [_jsx("div", { className: `w-12 h-12 rounded-xl bg-accent/20 flex items-center justify-center ${category.color}`, children: _jsx(Icon, { className: "w-6 h-6" }) }), _jsxs("div", { children: [_jsx("h3", { className: "text-foreground mb-1", children: category.title }), _jsxs("p", { className: "text-sm text-muted-foreground", children: [category.count, " recipes"] })] })] })] }, category.title));
                    }) })] }) }));
}
